import { render, staticRenderFns } from "./CompareStrategy.vue?vue&type=template&id=ae41d48a&scoped=true&"
import script from "./CompareStrategy.vue?vue&type=script&lang=js&"
export * from "./CompareStrategy.vue?vue&type=script&lang=js&"
import style0 from "./CompareStrategy.vue?vue&type=style&index=0&id=ae41d48a&lang=scss&scoped=true&"
import style1 from "./CompareStrategy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae41d48a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCol,VDataTable,VIcon,VRow,VSimpleTable,VSlider})
